<template>
  <div>
    <iframe v-if="method === 'iframe'" id="iframe" :src="url" scrolling="no" frameborder="0" :style="{'height' : iframeHeight}" @load="iframeLoaded"></iframe>
    <div v-if="method === 'html' && html" v-html="html"></div>
  </div>
</template>
<script>
  import http from 'axios'

  import Screen from '@/components/mixins/Screen'
  import Branding from '@/components/mixins/Branding'

  export default {
    name: 'AboutUsPage',

    props: {
      fullPath: {
        type: Boolean,
        default: false
      },
      staticcontentpath: {
        type: String,
        default: '/static/static-content/'
      },
      method: {
        type: String,
        default: 'html'
      }
    },

    mixins: [
      Screen,
      Branding
    ],

    data: () => ({
      iframeHeight: '400px',
      html: null
    }),

    computed: {
      infoPageName () {
        return this.$route.params.infopagename
      },
      staticContentPath () {
        return this.staticcontentpath
      },
      url () {
        var result = ''

        if (this.fullPath) {
          result = this.staticContentPath
        } else {
          result = this.staticContentPath + this.infoPageName + '.html'
        }

        return result
      }
    },
    methods: {
      getHtml () {
        if (this.method === 'html') {
          window.scroll(0, 0)
          http.get(this.url).then((response) => {
            if (response && response.data) {
              this.html = response.data
            }
          })
        }
      },
      iframeLoaded () {
        setTimeout(() => {
          this.iframeHeight = (document.getElementById('iframe').contentWindow.document.body.scrollHeight + 40) + 'px'
        }, 1)
      }
    },
    mounted () {
      this.getHtml()
    },
    created () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    watch: {
      url () {
        this.getHtml()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import "~@/css/config"

iframe
  width 100%
  height 100%
  // min-height 400px
.static-content
  .ca
    padding 5px 0
    .pd-icon
      width 30px
      display inline-flex
      align-items center
      justify-content center
  .ca_email .pd-icon
    font-size 15px


</style>



// WEBPACK FOOTER //
// src/components/common/StaticContent.vue